import TitleBlock, { TitleDescription } from '@anm/components/TitleBlock';
import getFromCdn from '@anm/helpers/getFromCdn';
import { flexColumn, flexRow, media } from '@anm/styles/helpers';
import styled from 'styled-components';

import { WrapperProps } from './types';

const mainTitleOnDesktopSmall = media.desktop_small`
  max-width: 504px;
`;

const mainTitleOnMobile = media.phone`
  padding: 0;
  max-width: unset;
  h1,
  h2,
  h3,
  h4 {
    font-size: 28px;
    line-height: 36px;
  }
  ${TitleDescription} {
    font-size: 14px;
    line-height: 22px;
  }
`;

export const MainTitle = styled(TitleBlock)`
  max-width: 72%;
  padding: 0 20px;
  h1,
  h2,
  h3,
  h4 {
    font-size: 40px;
    font-weight: 900;
    margin-top: 13px;
    line-height: 48px;
    margin-bottom: 6px;
  }
  ${TitleDescription} {
    font-size: 16px;
    line-height: 28px;
  }
  ${mainTitleOnMobile};
  ${mainTitleOnDesktopSmall};

  .blackLink {
    color: black;
    text-decoration: underline;
  }
`;

const wrapperOnMobile = media.phone<WrapperProps>`
  margin: 0;
  padding: 20px;
  border-radius: 0;
  padding-bottom: 145px;
  background: ${({ color, icon }) => `url(${getFromCdn(icon)})  bottom center / 320px 145px no-repeat ${color}`};
`;

const Wrapper = styled.div<WrapperProps>`
  ${flexColumn};
  min-height: 277px;
  border-radius: 20px;
  margin: 0 20px 10px;
  padding: 20px 20px 32px;
  background: ${({ color, icon, backgroundIconWidth, backgroundIconHeight }) =>
    `url(${getFromCdn(icon)})  bottom right / ${backgroundIconWidth}px ${backgroundIconHeight}px no-repeat ${color}`};
  margin-top: ${({ isEmbedView }) => (isEmbedView ? 20 : 0)}px;
  ${wrapperOnMobile};
`;

export const SearchAndFormatsContainer = styled.div`
  ${flexRow};
  margin-bottom: 29px;
`;

export default Wrapper;
